import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

type ApplyVoucherResponse = { data: { items: { cart: Cart } } };
export type ApplyVoucherError = { data: { errors?: string[] } };

export const applyVoucher = (code: string): Promise<Cart> =>
    (axios.post(`${API_URLS.CART}apply-voucher`, { code }) as unknown as Promise<ApplyVoucherResponse>).then(
        (response) => response.data.items.cart
    );
